//Imports
import React, { createContext, useState, useContext } from 'react';

//Create Context
const OrderContext = createContext();

//Export Context
export const useOrder = () => useContext(OrderContext);

//Order Provider Component
export const OrderProvider = ({ children }) => {
  //Order State
  const [orderDetails, setOrderDetails] = useState(null);

  //Save Order Data Function
  const saveOrderData = (data) => {
    setOrderDetails(prev => ({ ...prev, ...data }));
  };

  //Complete Order Function
  const completeOrder = (transactionRef) => {
    const finalOrder = {
      ...orderDetails,
      transactionRef,
      date: new Date().toISOString(),
      orderId: 'ORD-' + Math.random().toString(36).substr(2, 9).toUpperCase()
    };

    // Save to local storage representing the database
    const existingOrders = JSON.parse(localStorage.getItem('orders') || '[]');
    localStorage.setItem('orders', JSON.stringify([...existingOrders, finalOrder]));

    return finalOrder;
  };

  //Clear Order Function
  const clearOrder = () => setOrderDetails(null);

  //Return Order Context
  return (
    <OrderContext.Provider value={{
      orderDetails,
      saveOrderData,
      completeOrder,
      clearOrder
    }}>
      {children}
    </OrderContext.Provider>
  );
};
